import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {Button, Input, Modal, message, ConfigProvider, Switch} from "antd";
import {IconClose, IconCloseBlack, IconCloseWhite} from "../../Icon";
import {
    generateShortUUID,
    generateUUID2, getCookies, getImagePath, hasDesktopLicense, hasLicense, hasOnlyDesktopLicense, hasPremiumLicense,
    hasPublishLicense,
    imgPathPerfix,
    isDarkMode,
    isStringNullOrEmpty
} from "../../utils";
import {ipcSend} from "../../common/ipc";
import {useTranslation} from "react-i18next";
import {TPublishNote} from "../../index";
import {deletePublishNote, getNoteById, getPublishNoteById, updatePublishNote} from "../../../model";
import clipboard from "clipboardy";
import {getUserInfo, noteRemovePublish} from "../../api/Api";
import "./../Draw/DialogPublishToWeb.css"
import Global from "@/global";
import { getShareDataUrl} from "@/api/Aws";
import {ACCESS_TOKEN, MEDIIUM_Z_INDEX, PUBLISH_FRAME_SUF, SHARE_LIMIT_SIZE} from "@/Const";
import {APP_WEB, APP_WEB_WWW} from "@/electron_interactive";
import global from "@/global";
import {isZh} from "@/language";

let mszNoteId:string;//分享的ID
let mIsFrame:boolean;
const DialogPublishCardToWeb = forwardRef((props:{onCloseCallback:any}, ref)=> {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog,
        onShareWebFinished: onShareWebFinished,
        onIsDialogVisible: onIsDialogVisible,
        onCloseIndicator: onCloseIndicator
    }));

    const {t} = useTranslation();
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [hasLincese,setHasLincese] = useState(false);
    const [hasPublishLic, setHasPublishLic] = useState(false);
    const [hasPremiumLic, setHasPremiumLic] = useState(false);
    const [hasDesktopProLic, setHasDesktopProLic] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [enableUrl, setEnableUrl] = useState('');
    const [publishDesc, setPublishDesc] = useState(t("Create link"));
    const [isShowPageList, setIsShowPageList] = useState(true);
    const [isEnableNavigationKeys, setIsEnableNavigationKeys] = useState(true);
    const [isHtmlEmbedCode, setIsHtmlEmbedCode] = useState(false);
    const [createLinkWidth, setCreateLinkWidth] = useState('164px');
    const [cancelButtonText, setCancelButtonText] = useState('Cancel');
    const [isPublishing, setIsPublishing] = useState(false);
    const [isFramePresent, setIsFramePresent] = useState(false);
    const [activeTab, setActiveTab] = useState('download');//download,publish
    const [projectInfo, setProjectInfo] = useState({size:0});

    const mCallback = useRef<any>(null);

    const getArrayDownloadMenu = ()=>{
        const ARRAY_DOWNLOAD_MENU = [
            // {
            //     className: 'saveLocal',
            //     id: 'exportCanvasx',
            //     image: 'save_local_copy',
            //     title: t("Save local copy"),
            //     downloadImage: 'download_gray.png',
            //     textColor: isDarkMode() ? '#FFFFFF' : '#000000'
            // },
            {
                className: 'exportToPdf',
                id: 'exportPdf',
                image: 'export_to_pdf',
                title: t("Export to PDF"),
                downloadImage: 'download_gray.png',
                textColor: isDarkMode() ? '#FFFFFF' : '#000000'
            },
            {
                className: 'exportToMarkdown',
                id: 'exportMarkdown',
                image: 'export_to_markdown.svg',
                title: t("ExportToMarkdown"),
                downloadImage: 'download_gray.png',
                textColor: isDarkMode() ? '#FFFFFF' : '#000000'
            }
        ]
        return ARRAY_DOWNLOAD_MENU;
    }

    const [arrayDownloadMenus, setArrayDownloadMenus] = useState(getArrayDownloadMenu());


    const onShowDialog = async (szNoteId: string, callback:any) => {
        let isFrame = false;
        mszNoteId = szNoteId + (isFrame ? PUBLISH_FRAME_SUF : "");
        mCallback.current = callback;

        setIsFramePresent(isFrame);
        setActiveTab('download');
        setIsPublishing(false);

        setIsDialogVisible(true);
        setShareUrl('');
        setHasPublishLic(hasPublishLicense());
        setHasPremiumLic(hasPremiumLicense());
        setHasDesktopProLic(hasDesktopLicense());
        setHasLincese(hasLicense());

        if (!isStringNullOrEmpty(mszNoteId)) {
            const publishNote = await getPublishNoteById(mszNoteId);
            if (publishNote != null) {
                setShareUrl(publishNote.publishUrl);
                setCancelButtonText(t("Unpublished"))
                setPublishDesc(t("Publish Changes"))
            }
            // noteInfoById(mszNoteId,()=>{}).then(res=>{
            //
            // });
        }

        let szToken = localStorage.getItem(ACCESS_TOKEN);
        if (APP_WEB_WWW) {
            szToken = getCookies()['token'];
        }
        if (!isStringNullOrEmpty(szToken)) {
            getUserInfo({}, () => {
            }).then((res) => {
                Global.g_userInfo = res;

                setHasPublishLic(hasPublishLicense());
                setHasPremiumLic(hasPremiumLicense());
                setHasDesktopProLic(hasDesktopLicense());
                setHasLincese(hasLicense());
            })
        }
    }

    const onIsDialogVisible = () => {
        return isDialogVisible;
    }
    /**
     * web分享结果
     */
    const onShareWebFinished = (szWebUrl: string, noteId: string) => {
        setIsPublishing(false);
        if (!isDialogVisible) return;
        if (isStringNullOrEmpty(shareUrl)) {
            //first
            setCancelButtonText(t("Unpublished"));
            setPublishDesc(t("View site"));
        } else {
            setCancelButtonText(t("Unpublished"))
            setPublishDesc(t("Publish Changes"));
        }
        setShareUrl(szWebUrl);
        //保存到本地
        var pNote: TPublishNote = {
            id: mszNoteId, noteId: mszNoteId, publishUrl: szWebUrl,type:'card'
        }
        updatePublishNote(pNote);
    }

    const onCloseIndicator = () => {
        message.destroy();
        setIsPublishing(false);
    }

    /**
     * 复制地址
     */
    const onCopyUrl = (szUrl: string) => {
        clipboard.write(szUrl);
        message.info(t("Share addr has copyed"))
    }

    /**
     * 移除链接
     */
    const onRemoveLink = () => {
        window.showMessageBox(t("Tips"),t("Confirm remove share url"),t("Cancel"),t("Ok"),null,async ()=>{
            await deletePublishNote(mszNoteId);
            setShareUrl('');
            const szProjId = mszNoteId;
            const data = {
                id: szProjId,
                userId: Global.g_userInfo.id,
                title: '',
                publishedTitle: '',
                published: false,
                publishedContent: getShareDataUrl() + szProjId,
                content: '{type:"card"}'
            }
            noteRemovePublish(data, () => {

            }).then(res => {
                console.log("remove publish" + res);

                if (!Global.g_userInfo.noteCount) {
                    Global.g_userInfo.noteCount = 0;
                }
                Global.g_userInfo.noteCount = (Global.g_userInfo.noteCount - 1);
                if (Global.g_userInfo.noteCount < 0) {
                    Global.g_userInfo.noteCount = 0;
                }

                //刷新
                // window.globalRefreshList('onRemoveItemOnPublishTab_',mszNoteId);
            })
        })
        // Modal.confirm({
        //     content: t("Confirm remove share url"),
        //     centered: true,
        //     zIndex:9999999,
        //     cancelText:t('Cancel'),
        //     okText:t('Ok'),
        //     onOk() {
        //         deletePublishNote(mszNoteId);
        //         setShareUrl('');
        //         const szProjId = mszNoteId;
        //         const data = {
        //             id: szProjId,
        //             userId: Global.g_userInfo.id,
        //             title: '',
        //             publishedTitle: '',
        //             published: false,
        //             publishedContent: AWS_S3_PRE_DATA_URL + szProjId,
        //             content: '{type:"card"}'
        //         }
        //         noteRemovePublish(data, () => {
        //
        //         }).then(res => {
        //             console.log("remove publish" + res);
        //
        //             if (!Global.g_userInfo.noteCount) {
        //                 Global.g_userInfo.noteCount = 0;
        //             }
        //             Global.g_userInfo.noteCount = (Global.g_userInfo.noteCount - 1);
        //             if (Global.g_userInfo.noteCount < 0) {
        //                 Global.g_userInfo.noteCount = 0;
        //             }
        //         })
        //     },
        // })
    }

    const onPublishChange = () => {
        if (!Global.g_userInfo) {
            message.error(t("Please login first"));
            return;
        }
        setIsPublishing(true);
        mCallback.current('exportWeb', [], {showPageList: isShowPageList, enableNavKeys: isEnableNavigationKeys})
    }

    /**
     * 仅有desktoppro并且超过大小
     */
    const onlyDesktopProLicAndBeyondLimit = () => {
        //Desktop pro plus可以发布超过30MB的项目(desktop pro仍然只能发布20MB)
        let nMaxSize = SHARE_LIMIT_SIZE;
        // if (global.g_userInfo?.desktopProPlusLicense){
        //     nMaxSize = 30;
        // }
        return !hasPublishLic && !hasPremiumLic && hasDesktopProLic && projectInfo.size > nMaxSize * 1024 * 1024;
    }

    const onCloseDialog = ()=>{
        setIsDialogVisible(false);
        if (props.onCloseCallback){
            props.onCloseCallback();
        }
        message.destroy();
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    // Modal: {
                    //     /* 这里是你的组件 token */
                    //     contentBg:isFramePresent?'#2C2C2C':'white'
                    // },
                    Input: {
                        activeBorderColor: 'transparent'
                    }
                },
            }}
        >
            <Modal destroyOnClose={true} centered={true} maskClosable={true} zIndex={MEDIIUM_Z_INDEX} open={isDialogVisible}
                   footer={''} width='468px'
                   onCancel={(e) => {
                       onCloseDialog();
                   }} closeIcon={<IconCloseBlack/>}>
                {/*增加export*/}
                <div className={'font-size-12'} style={{
                    position: 'relative',
                    marginTop: '-2px',
                    marginBottom: '-10px',

                    display: 'flex',
                    flexDirection: 'column',
                    color: 'var(--text-color)'
                }}>
                    {/*<span className='dialog-title'>{isFramePresent?t("Publish frames to web"):t("Publish project to web")}</span>*/}
                    <span
                        className='dialog-title'>{t("ShareThisCard")}</span>
                    <div className='line-e4-tb-12' style={{background: 'var(--line-color)'}}></div>

                    <div className={'flex-row-vertical-center'}>
                        <div
                            className={(activeTab == 'download' ? 'tab-item-active' : 'tab-item') + ' flex-row-vertical-center'}
                            onClick={() => {
                                setActiveTab('download');
                            }}>
                            <img className={'img-16'}
                                 src={imgPathPerfix() + (activeTab == 'download' ? 'export_blue.png' : 'download_gray.png')}/>
                            <span
                                style={{color: activeTab == 'download' ? '#3670F7' : (isDarkMode() ? '#C8C8C8' : '#666666')}}
                                className={'ml-6'}>{t("Export")}</span>
                        </div>

                        <div
                            className={(activeTab == 'publish' ? 'tab-item-active' : 'tab-item') + ' flex-row-vertical-center ml-16'}
                            onClick={() => {
                                setActiveTab('publish')
                            }}>
                            <img className={'img-16'}
                                 src={imgPathPerfix() + (activeTab == 'publish' ? 'share_to_web_blue.png' : 'share_to_web_gray.png')}/>
                            <span
                                style={{color: activeTab == 'publish' ? '#3670F7' : (isDarkMode() ? '#C8C8C8' : '#666666')}}
                                className={'ml-6'}>{t("Publish to web")}</span>
                        </div>
                    </div>

                    <div style={{height: '0px'}}></div>
                    {
                        //导出部分
                        activeTab == 'download' &&
                        <div style={{marginBottom:'16px'}}>
                            {/*<span style={{color: 'var(--text-color-66666)'}}>{t("DownloadStaticCopy")}</span>*/}
                            {
                                arrayDownloadMenus.map(item =>
                                    <div key={item.id} className={'cursor-pointer download-item-' + item.className}
                                         onMouseEnter={() => {
                                             const arrayNews = [...getArrayDownloadMenu()];
                                             for (let i = 0; i < arrayNews.length; i++) {
                                                 arrayNews[i].downloadImage = 'download_gray.png'
                                                 arrayNews[i].textColor = isDarkMode() ? '#FFFFFF' : '#000000'

                                                 if (arrayNews[i].id == item.id) {
                                                     if (item.id == 'exportCanvasx') {
                                                         arrayNews[i].downloadImage = 'download_orange.png'
                                                         arrayNews[i].textColor = '#FF8718';
                                                     } else if (item.id == 'exportPdf') {
                                                         arrayNews[i].downloadImage = 'download_red.png'
                                                         arrayNews[i].textColor = '#FF5440';
                                                     } else if (item.id == 'exportPng') {
                                                         arrayNews[i].downloadImage = 'download_purple.png'
                                                         arrayNews[i].textColor = '#9440FF';
                                                     }else if (item.id == 'exportMarkdown'){
                                                         arrayNews[i].downloadImage = 'download_blue.svg'
                                                         arrayNews[i].textColor = '#4D62FF';
                                                     }
                                                 }
                                             }
                                             setArrayDownloadMenus(arrayNews);
                                         }} onMouseLeave={() => {
                                        const arrayNews = [...getArrayDownloadMenu()];
                                        arrayNews.forEach(p => {
                                            p.downloadImage = 'download_gray.png'
                                            p.textColor = isDarkMode() ? '#FFFFFF' : '#000000'
                                        })
                                        setArrayDownloadMenus(arrayNews);
                                    }} onClick={() => {
                                        /*********************/
                                        //这里不响应？算什么意思？
                                        /*********************/
                                    }} onMouseUp={(event) => {
                                        if (mCallback.current) {
                                            mCallback.current(item.id);
                                        }
                                        onCloseDialog();
                                    }}>
                                        <img style={{width: '32px', height: '36px'}}
                                             src={getImagePath(item.image)}/>
                                        <span style={{
                                            flexGrow: '1',
                                            marginLeft: '16px',
                                            color: item.textColor
                                        }}>{item.title}</span>
                                        <img data-id={'download'} className={'img-16'}
                                             src={getImagePath(item.downloadImage)}/>
                                    </div>
                                )
                            }

                            {/*<span className={'mt-16'}*/}
                            {/*      style={{*/}
                            {/*          color: 'var(--text-color-66666)',*/}
                            {/*          display: 'block'*/}
                            {/*      }}>{t("Current size") + ":" + projectInfo.formatSize ?? ''}</span>*/}
                        </div>
                    }

                    {/*//分享部分*/}
                    <div style={{display: activeTab == 'publish' ? 'initial' : 'none'}}>
                        <span className='mt-16' style={{display:'block'}}>{t("Create a link")}</span>
                        <div className='flex mt-8'>
                            <div className='flex-row-vertical-center input-border'
                                 style={{
                                     width: '100%', height: '32px', overflow: 'hidden',
                                     background: isStringNullOrEmpty(shareUrl) ? 'transparent' : 'transparent',
                                 }}>
                                <Input variant={"borderless"} placeholder='http://app.noteey.com/example'
                                       style={{flexFlow: '1', width: '100%',padding:'0'}} readOnly={true} value={shareUrl}/>
                                {/*<div className='flex-center hovered'*/}
                                {/*     onClick={()=>{*/}
                                {/*         onCopyUrl(shareUrl);*/}
                                {/*     }}*/}
                                {/*     style={{*/}
                                {/*         display: isStringNullOrEmpty(shareUrl) ? 'none' : 'flex',*/}
                                {/*    width: '36px',*/}
                                {/*    height: '34px',*/}
                                {/*    background: 'white',*/}
                                {/*    borderLeft: '1px solid #DDDEE3',*/}
                                {/*    flexShrink: '0'*/}
                                {/*}}>*/}
                                {/*    <img className='img-16' src={imgPathPerfix() + "copy_link.png"}/>*/}
                                {/*</div>*/}
                            </div>
                            {
                                shareUrl &&
                                <div style={{minWidth: '80px', height: '32px'}}
                                     className='button-solid-style ml-6 flex-center'
                                     onClick={() => onCopyUrl(shareUrl)}>{t("Copy link")}</div>
                            }

                        </div>

                        {
                            (hasPublishLicense() || hasDesktopLicense() || hasPremiumLicense()) && shareUrl && false &&
                            <ConfigProvider
                                theme={{
                                    components: {
                                        Switch: {
                                            // colorPrimary: '#2978FF',
                                            // colorTextQuaternary: isFramePresent?'#525252':'#E6E3EE',
                                            // colorTextTertiary: isFramePresent?'#525252':'#E6E3EE'
                                        }
                                    }
                                }}>
                                <div style={{marginTop: '8px'}}>
                                    <div className='row-item'>
                                        <span>{t("Show page list")}</span>
                                        <Switch style={{width: '30px'}} size={"small"} value={isShowPageList}
                                                onChange={(e) => {
                                                    setIsShowPageList(e);
                                                    setPublishDesc(t("Publish Changes"))
                                                }}/>
                                    </div>

                                    <div className='row-item'>
                                        <span>{t("Enable navigation keys")}</span>
                                        <Switch style={{width: '30px'}} size={"small"} value={isEnableNavigationKeys}
                                                onChange={(e) => {
                                                    setIsEnableNavigationKeys(e);
                                                    setPublishDesc(t("Publish Changes"))
                                                }}/>
                                    </div>

                                    <div className='row-item'>
                                        <span>{t("Generate HTML embed code")}</span>
                                        <Switch style={{width: '30px'}} size={"small"} value={isHtmlEmbedCode}
                                                onChange={(e) => {
                                                    setIsHtmlEmbedCode(e);
                                                    setEnableUrl('<iframe src="' + shareUrl + '" quality="high" width="640" height="480" align="middle" allowScriptAccess="sameDomain"></iframe>')
                                                }}/>
                                    </div>

                                    {
                                        isHtmlEmbedCode &&
                                        <div className='flex-row-vertical-center mt-10'>
                                            <div className='flex-row-vertical-center input-container'
                                                 style={{
                                                     width: '100%',
                                                     overflow: 'hidden',
                                                     height: '32px',
                                                     background: isStringNullOrEmpty(enableUrl) ? 'transparent' : 'transparent'
                                                 }}>
                                                <Input className={'input-border'} variant={"borderless"}
                                                       placeholder='http://app.noteey.com/example'
                                                       style={{flexFlow: '1', width: '100%'}} readOnly={true}
                                                       value={enableUrl}/>
                                                {/*<div className='flex-center hovered'*/}
                                                {/*     onClick={() => {*/}
                                                {/*         onCopyUrl(enableUrl);*/}
                                                {/*     }}*/}
                                                {/*     style={{*/}
                                                {/*         display: isStringNullOrEmpty(enableUrl) ? 'none' : 'flex',*/}
                                                {/*         width: '36px',*/}
                                                {/*         height: '34px',*/}
                                                {/*         background: 'white',*/}
                                                {/*         borderLeft: '1px solid #DDDEE3',*/}
                                                {/*         flexShrink: '0'*/}
                                                {/*     }}>*/}
                                                {/*    <img className='img-16' src={imgPathPerfix() + "copy_link.png"}/>*/}
                                                {/*</div>*/}
                                            </div>

                                            {
                                                shareUrl &&
                                                <Button className='button-solid-style ml-6'
                                                        onClick={() => onCopyUrl(shareUrl)}>{t("Copy link")}</Button>
                                            }

                                        </div>

                                    }

                                </div>

                            </ConfigProvider>
                        }

                        {
                            !shareUrl &&
                            <div className='flex-column-center'>
                                {
                                    (hasLincese) &&
                                    <div className='flex-center mt-22 ' style={{width: '100%'}}>
                                        <Button loading={isPublishing} onClick={() => {
                                            onPublishChange();
                                        }} className='button-solid-style'
                                                style={{minWidth: createLinkWidth, height: '38px'}}
                                                type={"primary"}>{t("Create link")}</Button>
                                    </div>
                                }
                                {
                                    (!hasLincese) &&
                                    <>
                                        <div className='flex-center mt-22 button-solid-style' style={{
                                            background: isDarkMode() ? '#131313' : '#DDDDDD',
                                            minWidth: '164px',
                                            height: '38px',
                                            marginTop: '32px',
                                            borderRadius: '8px'
                                        }}>
                                            <span style={{color: 'white'}}>{t("Create link")}</span>
                                            {/*<img className='img-14 ml-10' src={imgPathPerfix() + "white_lock.png"}/>*/}
                                        </div>

                                        {
                                            !hasLincese &&
                                            <span onClick={() => {
                                                onCloseDialog();
                                                if (APP_WEB_WWW || APP_WEB) {
                                                    window.open(import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                                } else {
                                                    if (isZh()) {
                                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                                    } else {
                                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                                    }
                                                }
                                            }}
                                                  className='link-color font-size-12 mt-12 cursor-pointer'>{t("UpgradeYouPlanToUnlockThisFeature")}</span>
                                        }
                                    </>
                                }
                            </div>
                        }
                        {
                            shareUrl &&
                            <div className='flex-center mt-12' style={{padding: '16px 16px 0 16px'}}>
                                <div className='flex-column-center ml-12'>
                                    <Button className='button-border-gray-style font-size-14 font-family-medium'
                                            style={{
                                                height: '38px',
                                                padding: '0px 1px 0px 1px',
                                                minWidth: '164px'
                                            }} onClick={() => {
                                        if (cancelButtonText === t("Unpublished")) {
                                            onRemoveLink()
                                        } else {
                                            onCloseDialog();
                                        }
                                    }}
                                    >{cancelButtonText}</Button>

                                    {
                                        (publishDesc != t("View site")) &&
                                        <span style={{visibility: "hidden"}}
                                              className='link-color cursor-pointer mt-12'>{t("View site")}</span>
                                    }

                                </div>


                                <div className='flex-column-center ml-12'>
                                    <Button className='button-solid-style font-size-14 font-family-medium'
                                            loading={isPublishing} onClick={() => {
                                        if (publishDesc === t("View site")) {
                                            ipcSend("open-url", shareUrl);
                                        } else {
                                            onPublishChange();
                                        }
                                    }} style={{
                                        height: '38px',
                                        padding: '0px 1px 0px 1px',
                                        minWidth: '164px',
                                        fontSize: '14px',
                                        background: onlyDesktopProLicAndBeyondLimit() ? (isDarkMode() ? '#131313' : '#F0F0F0') : 'var(--button-background-color)',
                                        color: onlyDesktopProLicAndBeyondLimit() ? 'var(--color-999)' : 'var(--button-text-color)',
                                        pointerEvents: onlyDesktopProLicAndBeyondLimit() ? 'none' : 'all'
                                    }}>{publishDesc}</Button>

                                    {
                                        (publishDesc != t("View site")) &&
                                        <span className='text-underline cursor-pointer mt-12' onClick={() => {
                                            ipcSend("open-url", shareUrl);
                                        }}>{t("View site")}</span>
                                    }
                                </div>

                            </div>
                        }
                        {/*//提示说明*/}
                        {
                            !hasPublishLic && !hasPremiumLic && hasDesktopProLic && projectInfo.size > SHARE_LIMIT_SIZE * 1024 * 1024 && shareUrl &&
                            <div style={{
                                color: 'var(--color-999)',
                                display: 'flex',
                                justifyItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '20px',
                                marginTop: '16px',
                                textAlign: 'center'
                            }}>
        <span
            style={{width: '340px'}}>{''}</span>
                            </div>
                        }

                        {
                            !hasPublishLic && !hasPremiumLic && hasDesktopProLic && projectInfo.size > SHARE_LIMIT_SIZE * 1024 * 1024 && !shareUrl &&
                            <div style={{
                                color: 'var(--color-999)',
                                display: 'flex',
                                justifyItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '20px',
                                marginTop: '16px',
                                textAlign: 'center'
                            }}>
        <span
            style={{width: '340px'}}>{''}</span>
                            </div>
                        }

                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    )
})

export default DialogPublishCardToWeb;